
//首页详情访问
export const apply = [
    {     
      path: '/customerDetail',
      name: 'customerDetail',
      component: () => import('@/views/salesManagement/customerManagement/customerDetail'),
      meta: { title: '客户详情', keepAlive: false }
    },
    {     
      path: '/warehouseDetail',
      name: 'warehouseDetail',
      component: () => import('@/views/warehouseManagement/warehouse/warehouseDetail'),
      meta: { title: '仓库详情', keepAlive: false }
    },
    {     
      path: '/warehouseManagement/goodsManagement/goodsManagementDetail',
      name: 'goodsManagementDetail',
      component: () => import('@/views/warehouseManagement/goodsManagement/goodsManagementDetail'),
      meta: { title: '物品详情', keepAlive: false }
    },
    {     
      path: '/stockCheckDetail',
      name: 'stockCheckDetail',
      component: () => import('@/views/warehouseManagement/stockCheck/stockCheckDetail'),
      meta: { title: '盘点单详情', keepAlive: false }
    },
   
]
  